module.exports = "/_next/static/images/lidovky-3fee49c85b5e1fd352363dd7a410a52c.png";